import chest from '~/assets/icons/chest.svg';
import { Text } from '~/components/ui/Text';
import { setCasesOverlayVisible, useLayoutDispatch } from '../../redux';
import {
	StyledButton,
	StyledContainer,
	StyledLeftContainer,
} from './OpenCaseBanner.styled';

const OpenCaseBanner = () => {
	const dispatch = useLayoutDispatch();

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<Text style={{ fontSize: 16, fontWeight: 500 }}>Тюнинг кейсы</Text>
				<Text style={{ fontSize: 14, opacity: 0.5 }}>
					Получи уникальные запчасти
					<br />
					на свою машину и получи
					<br />
					максимум эмоций!
				</Text>
			</StyledLeftContainer>
			<StyledButton onClick={() => dispatch(setCasesOverlayVisible(true))}>
				<img src={chest} />
			</StyledButton>
		</StyledContainer>
	);
};

export { OpenCaseBanner };
